import React, {ReactElement} from "react";
import {Route} from "react-router-dom";
import TfGeneratorPage from "../../pages/chase/fun/tf-generator/TfGeneratorPage";
import TfGeneratorResultPage from "../../pages/chase/fun/tf-generator/result/TfGeneratorResultPage";
import TfGeneratorOptionsPage from "../../pages/chase/fun/tf-generator/TfGeneratorOptionsPage";
import TfGeneratorListPage from "../../pages/chase/fun/tf-generator/list/TfGeneratorListPage";
import FursonaGeneratorPage from "../../pages/chase/fun/fursona-generator/FursonaGeneratorPage";
import FursonaGeneratorListPage from "../../pages/chase/fun/fursona-generator/list/FursonaGeneratorListPage";
import ChooseYourStarterPage from "../../pages/chase/fun/choose-your-starter/ChooseYourStarterPage";
import ChooseYourStarterResultPage from "../../pages/chase/fun/choose-your-starter/result/ChooseYourStarterResultPage";

class FunRouter {

    public static getRoutes(): ReactElement {
        return (
            <>
                <Route path="fursona-generator">
                    <Route index element={<FursonaGeneratorPage/>}/>
                    <Route path="list" element={<FursonaGeneratorListPage/>}/>
                </Route>
                <Route path="tf-generator" element={<TfGeneratorPage/>}>
                    <Route index element={<TfGeneratorOptionsPage/>}/>
                    <Route path="result" element={<TfGeneratorResultPage/>}/>
                    <Route path="list" element={<TfGeneratorListPage/>}/>
                </Route>
                <Route path="choose-your-starter">
                    <Route index element={<ChooseYourStarterPage/>}/>
                    <Route path="result" element={<ChooseYourStarterResultPage/>}/>
                </Route>
            </>
        );
    }
}

export default FunRouter;